import React from 'react';

import attributeRow from './attribute_row';
import AssignmentPropTypes from '../assignment_prop_types';

export default class ContractDetails extends React.Component {
  static propTypes = {
    ...AssignmentPropTypes
  };

  render() {
    const { assignment } = this.props;
    const { selectedProperty } = assignment;
    return (
      <div className="table-container">
        <table className="table">
          <tbody>
            {attributeRow('Close Date', assignment.closeDate)}
            {attributeRow('Transaction Value', assignment.assignmentTransactionValue)}
            {attributeRow('Address', selectedProperty.address)}
            {attributeRow('Zip', selectedProperty.zip)}
            {attributeRow('City', selectedProperty.city)}
            {attributeRow('State', selectedProperty.state)}
            {attributeRow('County', selectedProperty.county)}
          </tbody>
        </table>
      </div>
    );
  }
}
